import Styles from './ChallengeKnowledgeCheckStart.module.scss'
import { useParams, useNavigate } from 'react-router-dom';
// Components import
import { InstructionCard } from 'components/global/InstructionCard/InstructionCard';
// Other import
import axios from 'axios';


export function ChallengeKnowledgeCheckStart(props) {
    const { challenge_id } = useParams();
    const { stream_id } = useParams();

    const navigate = useNavigate();

    const challengeLevelOneInstructions =
        props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheckStart.instructions', { returnObjects: true });


    const handleStartClick = () => {
        navigate(`/challenges/${challenge_id}/knowledge/attempt`);
    }

    const handleBackClick = () => {
        const options = {
            method: "POST",
            url: `/api/user/streams/${stream_id}/challenges/${challenge_id}/quit`,
            headers: {
                "accept": "application/json",
            },
        };
        axios
            .request(options)
            .then(function (response) {
                navigate(`/streams/${stream_id}/challenges`);
            })
            .catch((err) => {
                let status = err.response.status;
                console.log("error", status);
                navigate('/oops');
            });
    }

    return (
        <div id='CardContainer' className={Styles.CardContainer}>
            <InstructionCard
                instructions={challengeLevelOneInstructions}
                handleStartClick={handleStartClick}
                handleBackClick={handleBackClick}
                buttonText={props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheckStart.button')}
            />
        </div>
    )
}